<nav [mat-stretch-tabs]="false" [tabPanel]="tabPanel()" mat-align-tabs="center" mat-tab-nav-bar>
  @for (section of sections; track section) {
    @if (section.code?.substring(4); as tabKey) {
      @if (section.active) {
        <a
          [active]="activeEntity() === tabKey"
          [disabled]="_allDisabledTabs.includes(tabKey)"
                [matTooltip]="
                    _allDisabledTabs.includes(tabKey)
                        ? ('research.search.academic.units.tab.' + (_labelOverrideMap[tabKey] ?? tabKey) + '.inactive'
                          | translate)
                        : null
                "
          [queryParams]="unitLinkQueryParams(tabKey)"
          [routerLink]="_allDisabledTabs.includes(tabKey) ? null : unitSearchLink(tabKey)"
          mat-tab-link
          >{{ 'esploro.research.conf.research.portal.label.prefix.orgTree.' + section.code | translate
          }}@if (sectionCounts$[tabKey] | async; as count) {
          @if (!hideCounts() && tabKey !== 'homepage' && count > 0) {
            &nbsp;({{ count }})
          }
        }
      </a>
    }
  }
}
</nav>
